// extracted by mini-css-extract-plugin
export default {"statusBody":"RemoteStatus_statusBody__vhgG6","statusText":"RemoteStatus_statusText__xR7xo"};